exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Page .Dashboard__Table .Table__Row .Table__Cell:first-child {\n  font-weight: 700;\n  color: #ff9b1e; }\n", ""]);

// exports
